import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            margin: `${theme.spacing(2)} 0`,
            padding: `0 0 ${theme.spacing(3)} 0 !important`,
        },
        checkbox: {
            padding: '0px !important',
        },
        input: {
            backgroundColor: theme.palette.secondary[50],
            paddingLeft: theme.spacing(0.25),
        },
        inputLabel: {
            display: 'none',
        },
        enumInput: {
            '& .MuiTypography-root': {
                padding: '0px !important',
            },
        },
        link: {
            paddingBottom: 0,
        },
        tableCellHead: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        tableCell: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textAlign: 'right',
            '&:nth-of-type(13)': {
                textAlign: 'right',
            },
        },
        btnContainer: {
            width: 'fit-content',
            display: 'inline-flex',
        },
        classNameLabel: {
            flexBasis: 'content',
        },
    }
})

export default useStyles
